import {eraseVersion, loadAllVersion, loadVersion, newVersion} from "./version-page-service";
import {getLastElementOr} from "../../utils";

const appDbPrefix ="mobileagent";
export const saveVersion = (version, isImportant, changeLog) => {
	let versionData = {
		name: version,
		important: !!isImportant,
		changeLog: changeLog
	}
	return newVersion(appDbPrefix, versionData);
};

export const getVersion = (): Promise<any> => {

	return loadVersion( appDbPrefix );
};

export const getAllVersions = () => {
	return (
		loadAllVersion( appDbPrefix )
			.then((result: {status: string; data: any[]}) => result.data )
			.catch((e: any) => Promise.reject( e ))
	);
};


export const deleteVersion = versionID => {
	return eraseVersion( appDbPrefix, versionID );
};
